import React from 'react'
import { Icon } from '@chakra-ui/react'

const CircleIcon2 = ({ ...props }) => {
  return (
    <Icon
      width="71"
      height="122"
      viewBox="0 0 71 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="10"
        cy="61"
        r="58.5"
        fill="#83B53C"
        stroke="white"
        stroke-width="5"
      />
    </Icon>
  )
}

export default CircleIcon2
